import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat, dateToPlainFormat } from '@/utils'

export interface MyNotice {
  id: number
  branchCode: SystemCode
  displayBranchCode: SystemCode
  displayPlaceCode: SystemCode
  displayStartDate: string
  displayEndDate: string
  body: string
  registeredDate: string
  revision: number
}

export function MyNoticeFromJSON(json: any): MyNotice {
  return {
    id: exists(json, 'id') ? json.id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    displayBranchCode: exists(json, 'display_branch_code')
      ? SystemCodeFromJSON(json.display_branch_code)
      : defaultSystemCode(),
    displayPlaceCode: exists(json, 'display_place_code')
      ? SystemCodeFromJSON(json.display_place_code)
      : defaultSystemCode(),
    displayStartDate: exists(json, 'display_start_date')
      ? dateToPlainFormat(json.display_start_date)
      : '',
    displayEndDate: exists(json, 'display_end_date')
      ? dateToPlainFormat(json.display_end_date)
      : '',
    body: exists(json, 'body') ? json.body : '',
    registeredDate: exists(json, 'registered_date')
      ? dateTimeToPlainFormat(json.registered_date)
      : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
